import React from 'react';
import { Link } from 'react-router-dom';
import { SprayCan, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './NotFound.css';

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <div className="not-found-page" data-testid="not-found-page">
      <div className="not-found-content">
        <div className="not-found-icon" aria-hidden="true">
          <SprayCan size={40} strokeWidth={1.25} />
        </div>
        <p className="not-found-code" data-testid="not-found-code">{t('notFoundCode')}</p>
        <h1 className="not-found-title" data-testid="not-found-title">{t('notFoundTitle')}</h1>
        <p className="not-found-message" data-testid="not-found-message">{t('notFoundMessage')}</p>
        <div className="not-found-actions">
          <Link to="/" className="not-found-btn not-found-btn-primary" data-testid="not-found-home-link">
            <ArrowLeft size={15} />
            {t('notFoundHomeBtn')}
          </Link>
          <Link to="/products" className="not-found-btn not-found-btn-secondary" data-testid="not-found-shop-link">
            {t('notFoundShopBtn')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
